import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { FEATURE_FLAGS } from '@feature-flags/feature-flags.constants'
import { FEATURES } from '@feature-flags/features.constants'
import { FEATURE_FLAG_MODULE_CUSTOMER_LIST } from '@/environment/environment.constant'

class NavBar extends Component {
  render() {
    const { isSuperAdmin, isCompanyAdmin, isProviderAdmin } = this.props.user
    const isProd = location.hostname.includes('admin.meetingdoctors.com')
    const panelUrl = isProd ? 'https://panel.meetingdoctors.com' : 'https://panel.staging.meetingdoctors.com'
    // DEVELOPMENT
    if (isSuperAdmin) {
      return (
        <>
          <div className="sidebar-section">
            <div className="title">
              <Trans>Administración</Trans>
            </div>

            <Link to={'/companies'}>
              <Trans>Compañías</Trans>
            </Link>
            <Link to={'/administrator'}>
              <Trans>Administradores</Trans>
            </Link>
            <Link to={'/professional'}>
              <Trans>Profesionales</Trans>
            </Link>
            <Link to={'/schedules'}>
              <Trans>Horarios</Trans>
            </Link>
            {FEATURE_FLAG_MODULE_CUSTOMER_LIST && (
              <Link to={'/customers'}>
                <Trans>Usuarios</Trans>
              </Link>
            )}
            {import.meta.env.VITE_REACT_APP_ENV === 'DEVELOPMENT' && (
              <Link to={'/relations'}>
                <Trans>Relaciones</Trans>
              </Link>
            )}
            <Link to={'/groups'}>
              <Trans>Grupos</Trans>
            </Link>
            <Link to={'/sentence'}>
              <Trans>Frases Hechas</Trans>
            </Link>
            <Link to={'/derivations'}>
              <Trans>Derivaciones</Trans>
            </Link>
            <Link to={'/speciality'}>
              <Trans>Especialidades</Trans>
            </Link>
            {FEATURE_FLAGS[FEATURES.CONTENT] ? (
              <a href={`${panelUrl}/main/feeds`} target="_blank">
                <Trans>Contenido</Trans>
              </a>
            ) : null}
          </div>

          <div className="sidebar-section">
            <div className="title">
              <Trans>Analiticas</Trans>
            </div>
            <Link to="/download">
              <Trans>Descargas</Trans>
            </Link>
            <Link to="/usage">
              <Trans>Uso del servicio</Trans>
            </Link>
            <Link to="/activity">
              <Trans>Consultas</Trans>
            </Link>
            <Link to="/customer">
              <Trans>Usuarios activos</Trans>
            </Link>
            <Link to="/nps">
              <Trans>(NUEVA) Calidad del servicio</Trans>
            </Link>
            <Link to="/qos">
              <Trans>Calidad del servicio</Trans>
            </Link>
            <Link to="/responseTime">
              <Trans>Tiempos de respuesta</Trans>
            </Link>
          </div>

          <div className="sidebar-section">
            <div className="title">
              <Trans>Servicio</Trans>
            </div>
            <Link to="/room">
              <Trans>Chats</Trans>
            </Link>
            <Link to="/monitoring">
              <Trans>Monitoreo</Trans>
            </Link>
          </div>
        </>
      )
    }

    if (isCompanyAdmin && isProviderAdmin) {
      // this is PAAS
      return (
        <>
          <div className="sidebar-section">
            <div className="title">
              <Trans>Administración</Trans>
            </div>

            <Link to={'/professional'}>
              <Trans>Profesionales</Trans>
            </Link>
            <Link to={'/schedules'}>
              <Trans>Horarios</Trans>
            </Link>
            <Link to={'/customers'}>
              <Trans>Usuarios</Trans>
            </Link>
            {import.meta.env.VITE_REACT_APP_ENV === 'DEVELOPMENT' && (
              <Link to={'/relations'}>
                <Trans>Relaciones</Trans>
              </Link>
            )}
            <Link to={'/sentence'}>
              <Trans>Frases Hechas</Trans>
            </Link>
          </div>

          <div className="sidebar-section">
            <div className="title">
              <Trans>Analiticas</Trans>
            </div>

            <Link to="/download">
              <Trans>Descargas</Trans>
            </Link>
            <Link to="/usage">
              <Trans>Uso del servicio</Trans>
            </Link>
            <Link to="/activity">
              <Trans>Consultas</Trans>
            </Link>
            <Link to="/customer">
              <Trans>Usuarios activos</Trans>
            </Link>
            <Link to="/qos">
              <Trans>Calidad del servicio</Trans>
            </Link>
            <Link to="/responseTime">
              <Trans>Tiempos de respuesta</Trans>
            </Link>
          </div>

          <div className="sidebar-section">
            <div className="title">
              <Trans>Servicio</Trans>
            </div>

            <Link to="/room">
              <Trans>Chats</Trans>
            </Link>
          </div>
        </>
      )
    }

    if (isCompanyAdmin) {
      return (
        <>
          <div className="sidebar-section">
            <div className="title">
              <Trans>Administración</Trans>
            </div>

            <Link to={'/professional'}>
              <Trans>Profesionales</Trans>
            </Link>
            <Link to={'/schedules'}>
              <Trans>Horarios</Trans>
            </Link>
            <Link to={'/customers'}>
              <Trans>Usuarios</Trans>
            </Link>
            <Link to={'/sentence'}>
              <Trans>Frases Hechas</Trans>
            </Link>
          </div>

          <div className="sidebar-section">
            <div className="title">
              <Trans>Analiticas</Trans>
            </div>

            <Link to="/download">
              <Trans>Descargas</Trans>
            </Link>
            <Link to="/usage">
              <Trans>Uso del servicio</Trans>
            </Link>
            <Link to="/activity">
              <Trans>Consultas</Trans>
            </Link>
            <Link to="/customer">
              <Trans>Usuarios activos</Trans>
            </Link>
            <Link to="/qos">
              <Trans>Calidad del servicio</Trans>
            </Link>
            <Link to="/responseTime">
              <Trans>Tiempos de respuesta</Trans>
            </Link>
          </div>

          <div className="sidebar-section">
            <div className="title">
              <Trans>Servicio</Trans>
            </div>

            <Link to="/room">
              <Trans>Chats</Trans>
            </Link>
          </div>
        </>
      )
    }

    if (isProviderAdmin) {
      return (
        <>
          <div className="sidebar-section">
            <div className="title">
              <Trans>Administración</Trans>
            </div>
            <Link to={'/professional'}>
              <Trans>Profesionales</Trans>
            </Link>
            <Link to={'/schedules'}>
              <Trans>Horarios</Trans>
            </Link>
          </div>

          <div className="sidebar-section">
            <div className="title">
              <Trans>Analiticas</Trans>
            </div>
            <Link to="/qos">
              <Trans>Calidad del servicio</Trans>
            </Link>
            <Link to="/responseTime">
              <Trans>Tiempos de respuesta</Trans>
            </Link>
          </div>

          <div className="sidebar-section">
            <div className="title">
              <Trans>Servicio</Trans>
            </div>
            <Link to="/room">
              <Trans>Chats</Trans>
            </Link>
            <Link to="/monitoring">
              <Trans>Monitoreo</Trans>
            </Link>
          </div>
        </>
      )
    }
  }
}

export default withTranslation()(NavBar)
